import './style.css';

type TitleTheme = 'light' | 'dark' | 'accent';

interface TitleLayoutProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  twoLines?: boolean;
  theme?: TitleTheme;
  [key: string]: any;
}

const TitleLayout = ({
  title,
  subtitle = '',
  twoLines = false,
  theme = 'light',
  ...props
}: TitleLayoutProps) => {
  const themeClass = `theme-${theme}`;

  if (twoLines) {
    return (
      <div id="TitleLayoutTwoLine" {...props}>
        <p className={`title ${themeClass}`}>{title}</p>
        <p className={`subtitle ${themeClass}`}>{subtitle}</p>
      </div>
    );
  } else {
    return (
      <div id="TitleLayout" {...props}>
        <p className={`title ${themeClass}`}>{title}</p>
        <p className={`subtitle ${themeClass}`}>{subtitle}</p>
      </div>
    );
  }
};

export default TitleLayout;